export const CATEGORY = {
    NEXT: "next",
    WAITING: "waiting",
    SCHEDULED: "scheduled",
    SOMEDAY: "someday",
    FOCUS: "focus"
}